import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import DataTable from 'react-data-table-component';

class ViewPatientData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedEpisodeId: 'Pre-Op',
            painData: [{
                preEpisode: '',
                havePain: '',
                painRate: '',
                anyMedication: '',
                medFrequency: '',
                seenPainMgmtSpecialist: '',
                useNSAIDMedication: '',
                useNarcoticMedication: '',
                goalPainExpectation: ''
            }],
            painData1: [{
                episodes: '',
                havePain: '',
                painRate: '',
                anyMedication: '',
                medFrequency: '',
                seenPainMgmtSpecialist: '',
                useNSAIDMedication: '',
                useNarcoticMedication: '',
                goalPainExpectation: ''
            }],
            painData2: [{
                episodes: '',
                havePain: '',
                painRate: '',
                anyMedication: '',
                medFrequency: '',
                seenPainMgmtSpecialist: '',
                useNSAIDMedication: '',
                useNarcoticMedication: '',
                goalPainExpectation: ''
            }],
            painData3: [{
                episodes: '',
                havePain: '',
                painRate: '',
                anyMedication: '',
                medFrequency: '',
                seenPainMgmtSpecialist: '',
                useNSAIDMedication: '',
                useNarcoticMedication: '',
                goalPainExpectation: ''
            }],
            painData4: [{
                episodes: '',
                havePain: '',
                painRate: '',
                anyMedication: '',
                medFrequency: '',
                seenPainMgmtSpecialist: '',
                useNSAIDMedication: '',
                useNarcoticMedication: '',
                goalPainExpectation: ''
            }],
            editedId: '-1',
            painDataResult: [],
            painDataResult1: [],
            painDataResult2: [],
            painDataResult3: [],
            painDataResult4: [],
            fields: {},
            barChartValues: [],
            data: [],
            postOpOneData: [],
            postOpTwoData: [],
            postOpThreeData: [],
            postOpFourData: [],
            pageNum: null,
            loadedAgentSkills: [],
            loadedEpisodes: [],
            loadedEpisodeData: [],
            loadedSkillMetaData: {},
            episodeDataResults: [],
            graphParameters: [],
            selectedGraphParameter: '',
            episodeNames: [],
            formattedDate: "",
            formattedTime: ""

        }

        this.episodeNameMap = {};
    }



    fetchPatientDetails = () => {
        var episodeDataController = this;
        $.ajax({
            url: "/my-jeeva-api/fetch-patient-data",

            method: 'GET',
            headers: {

                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            }, data: {
                patientId: localStorage.getItem('patientAddmissionId'),

            },
            success: function (res) {
                if (res.success === true) {
                    for (var i = 0; i < res.result.length; i++) {
                        episodeDataController.state.data.push(res.result[i].currentPainRate);
                        episodeDataController.state.painData.preEpisode = 'Pre-Op';
                        episodeDataController.state.painData.havePain = res.result[i].painToday;
                        episodeDataController.state.painData.painRate = res.result[i].currentPainRate;
                        episodeDataController.state.painData.seenPainMgmtSpecialist = res.result[i].seenPainMgmtSpecialist;
                        episodeDataController.state.painData.useNSAIDMedication = res.result[i].useNSAIDMedication;
                        episodeDataController.state.painData.useNarcoticMedication = res.result[i].useNarcoticMedication;
                        episodeDataController.state.painData.goalPainExpectation = res.result[i].goalPainExpectation;
                        episodeDataController.state.painDataResult.push(episodeDataController.state.painData);

                        episodeDataController.setState(episodeDataController.state);
                    }
                } else {
                    // episodeDataController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                var errorMessage = xhr.status + ': ' + xhr.statusText;
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            }
        });
    }

    fetchSkillMetaData = () => {
        var episodeDataController = this;
        episodeDataController.state.loadedSkillMetaData = [];
        $.ajax({
            url: "/my-jeeva-api/skill-meta-data",

            method: 'GET',
            headers: {

                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                skillId: this.episodeMap[this.state.selectedEpisodeId].skillId
            },
            success: function (res) {
                if (res.success === true) {
                    episodeDataController.state.loadedSkillMetaData = res.result;
                    episodeDataController.fetchEpisodeData();
                } else {
                    // episodeDataController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                var errorMessage = xhr.status + ': ' + xhr.statusText;
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            }
        });
    }

    fetchEpisodeData = () => {
        var episodeDataController = this;
        $.ajax({
            url: "/my-jeeva-api/episode-data",

            method: 'GET',
            headers: {

                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                episodeId: this.state.selectedEpisodeId
            },
            success: function (res) {
                if (res.success === true) {
                    var skillDataResultSet = [];
                    var episodeData;
                    var skillDataResult;
                    for (var i = 0; i < res.result.length; i++) {
                        episodeData = res.result[i];
                        skillDataResult = JSON.parse(episodeData.jsonData);
                        skillDataResultSet.push(skillDataResult);
                    }
                    episodeDataController.state.loadedEpisodeData = res.result;
                    if(res.result.length !== 0){
                        var createdDate = res.result[0].createdDate;
                        var date = new Date(...createdDate);
                        var formattedDate = date.toLocaleDateString('en-US', {
                            month: '2-digit',
                            day: '2-digit',
                            year: 'numeric',
                        });
                        var formattedTime = date.toLocaleTimeString('en-US', {
                            hour: '2-digit',
                            minute: '2-digit',
                        });
                        episodeDataController.state.formattedDate = formattedDate;
                        episodeDataController.state.formattedTime = formattedTime;
                    }   
                    episodeDataController.state.episodeDataResults = skillDataResultSet;
                    console.log("relevant data records :" + JSON.stringify(skillDataResultSet));
                    episodeDataController.setState(episodeDataController.state);
                } else {
                    // episodeDataController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                var errorMessage = xhr.status + ': ' + xhr.statusText;
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            }
        });
    }

    fetchPatientPainData = () => {
        var episodeDataController = this;
        $.ajax({
            url: "/my-jeeva-api/fetch-patient-pain-data",

            method: 'GET',
            headers: {

                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            }, data: {
                patientId: localStorage.getItem('patientAddmissionId'),

            },
            success: function (res) {
                if (res.success === true) {

                } else {
                    // episodeDataController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                var errorMessage = xhr.status + ': ' + xhr.statusText;
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            }
        });
    }

    fetchAgentEpisodes() {
        var episodeDataController = this;
        this.state.episodeNames = [];
        this.episodeNameMap = {};
        $.ajax({
            url: "/my-jeeva-api/episode",

            method: 'GET',
            data: {
                patientAdmissionId: localStorage.getItem('patientAddmissionId')
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    episodeDataController.state.showLoader = true;
                    //TODO: Remove loadedData after checking usage
                    episodeDataController.state.loadedData = res.result;
                    episodeDataController.state.loadedEpisodes = res.result;
                    episodeDataController.episodeMap = [];
                    episodeDataController.episodeNameMap = {};
                    var episode;
                    for (var i in res.result) {
                        episode = res.result[i];
                        episodeDataController.episodeMap[episode.id] = episode;
                        episodeDataController.episodeNameMap[episode.name] = episode;
                        episodeDataController.state.episodeNames.push(episode.name);
                    }
                    episodeDataController.state.disableAddButton = false;
                    //episodeDataController.setState(episodeDataController.state);
                    episodeDataController.fetchAgentSkills();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/my-jeeva/";
                }
            }
        });
    }


    fetchAgentSkills() {
        var episodeDataContoller = this;
        var responseData = []
        $.ajax(
            {
                url: "/my-jeeva-api/agent-skills",

                method: 'GET',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                },
                data: {
                    treatmentId: localStorage.getItem("selectedTreatmentId")
                },
                success: function (res) {
                    if (res.success === true) {
                        episodeDataContoller.state.showLoader = true;
                        episodeDataContoller.setState(episodeDataContoller.state);
                        var response = res.result;
                        var length = response.length;
                        episodeDataContoller.state.loadedAgentSkills = [];
                        episodeDataContoller.skillMap = {};

                        for (var i = 0; i < length; i++) {

                            episodeDataContoller.skillMap[response[i].id] = response[i].description;
                            episodeDataContoller.state.loadedAgentSkills[i] = (response[i]);
                            episodeDataContoller.setState(episodeDataContoller.state);
                        }
                    } else {
                        episodeDataContoller.notifyFailedLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/";
                    }
                }
            }
        )

    }

    fetchGraphParameters() {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/trendy-meta-data",
            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                patientAdmissionId: localStorage.getItem('patientAddmissionId')
            },
            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;
                    thisController.state.showLoader = true;
                    thisController.state.graphParameters = messages;
                    thisController.setState(thisController.state);
                    console.log("The display names are : " + messages);
                } else {
                    // thisController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/my-jeeva/";
                }
            }
        });
    }

    fetchGraphParameterValues() {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/episode-slot-values",
            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                patientAdmissionId: localStorage.getItem('patientAddmissionId'),
                slotName: this.state.selectedGraphParameter
            },
            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;
                    thisController.state.showLoader = true;
                    var graphData;
                    var graphDataMap = {};
                    for (var i = 0; i < res.result.length; i++) {
                        graphData = res.result[i];
                        graphDataMap[graphData.episodeId] = graphData;
                    }

                    var episodeNameMap = thisController.episodeNameMap;
                    var episodeNames = thisController.state.episodeNames;
                    var graphParamValues = [];
                    var episodeObj;
                    var episodeName;
                    var episodeGraphData;
                    for (var i = 0; i < episodeNames.length; i++) {
                        episodeName = episodeNames[i];
                        episodeObj = episodeNameMap[episodeName];
                        episodeGraphData = graphDataMap[episodeObj.id];
                        if (episodeGraphData) {
                            graphParamValues.push(episodeGraphData.dataValue);
                        }
                    }
                    thisController.state.graphParamValues = graphParamValues;
                    thisController.setState(thisController.state);

                } else {
                    // thisController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/my-jeeva/";
                }
            }
        });
    }

    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }

    notifyFailedLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red",
        });
    }
    componentDidMount() {
        this.fetchAgentEpisodes();
        this.fetchGraphParameters();

        setTimeout(() => {


            this.fetchPatientDetails();
            this.fetchEpisodeData();
        }, 300);
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }
    onEpisodeSelection = (e) => {
        document.getElementById("selectedEpisodeId").value = e.target.value;
        this.state.selectedEpisodeId = e.target.value;
        this.fetchSkillMetaData();
        this.setState({ selectedEpisodeId: e.target.value });
        this.setState(this.state);
        e.preventDefault();
    }

    onGraphParamChange = (e) => {
        e.preventDefault();
        document.getElementById("selectedGraphParameter").value = e.target.value;
        this.state.selectedGraphParameter = e.target.value;
        this.fetchGraphParameterValues();
        console.log("The slot name is :" + e.target.value);
    }

    render() {
        const dynamicCols = [];
        var col;
        var patientDataController = this;
        for (var i in this.state.loadedSkillMetaData) {
            var skillMetaData = (function () { return patientDataController.state.loadedSkillMetaData[i] })();
            var dataSelector = (function (skillMetaData) {
                return (row) => {
                    return (

                        //TODO: finish it by looking up the
                        <div name="episodeDataRecords">
                            <div className="textarea" Align='left'
                                style={{
                                    background: 'white', height: "2.7em", resize: 'none',
                                    paddingLeft: '2px', paddingTop: '6px', width: '98%',
                                    border: 'none'
                                }}
                                id={"episodeDataRecords" + row.index}
                            ><b>{row[skillMetaData.slotName]}</b>
                            </div>
                        </div>)
                }
            })(skillMetaData);
            col = {
                name: <b style={{ fontSize: '16px' }} >{skillMetaData.displayName}</b>,
                selector: dataSelector
            };
            dynamicCols.push(col);
        }

        // Adding Date column
        const dateColumn = {
            name: <b style={{ fontSize: '16px' }}>Date</b>,
            selector: 'formattedDate'
        };
        dynamicCols.push(dateColumn);

        // Adding Time column
        const timeColumn = {
            name: <b style={{ fontSize: '16px' }}>Time</b>,
            selector: 'formattedTime'
        };
        dynamicCols.push(timeColumn);

        return (
            <div id="tabPage" >
                <div className="content" style={{ backgroundColor: "#F9F9FB", overflowY: 'scroll', overflowX: 'hidden', height: '60vh' }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <div className="container-fluid">
                        <div className='col-sm-4' style={{ marginLeft: '40em' }}>

                            <select className="input-group form-control select2 "
                                id="selectedGraphParameter"
                                onChange={(e) => this.onGraphParamChange(e)}
                                style={{
                                    background: 'white', border: 'none',
                                    border: '1px solid #D2D4DC', borderRadius: '2px', width: '15vw'
                                }} >

                                {this.state.graphParameters.map(graphParam => (
                                    <option key={graphParam.id} value={graphParam.slotName} >
                                        {graphParam.displayName}
                                    </option>
                                ))}
                                <option hidden value='Select Display Name'>Choose Parameter</option>

                            </select>
                        </div>
                        <Bar
                            data={{
                                // Name of the variables on x-axies for each bar
                                labels: this.state.episodeNames,
                                datasets: [
                                    {
                                        // Label for bars
                                        label: this.state.selectedGraphParameter,
                                        // Data or value of your each variable
                                        data: this.state.graphParamValues,
                                        // Color of each bar
                                        backgroundColor: "red",
                                        // Border color of each bar
                                        borderColor: "red",
                                        borderWidth: 0.5,
                                    },
                                ],
                            }}
                            // Height of graph
                            height={400}
                            options={{
                                maintainAspectRatio: false,
                                scales: {
                                    yAxes: [
                                        {
                                            ticks: {
                                                // The y-axis value will start from zero
                                                beginAtZero: true,
                                                // scales: 100
                                                max: 10
                                            },
                                        },
                                    ],
                                },
                                legend: {
                                    onClick: null,
                                    labels: {
                                        fontSize: 15,
                                        textDecoration: "none",
                                    }
                                },
                            }}
                        />

                    </div>
                    <div className='row' style={{ marginTop: '10vh' }}>
                        <div className='col-sm-6'>
                            <h1 style={{
                                fontSize: '14px',
                                letterSpacing: '-0.1px',
                                textAlign: 'left',
                                color: '#282a65', marginBottom: '2vw', marginLeft: '1vw'
                            }}>Patient Pain Data</h1>
                        </div>
                        <div className='col-sm-2'>

                        </div>
                        <div className='col-sm-4'>

                            <select className="input-group form-control select2 "
                                id="selectedEpisodeId"
                                onChange={(e) => this.onEpisodeSelection(e)}
                                //value={this.state.selectedEpisodeId}
                                style={{
                                    background: 'white', border: 'none',
                                    border: '1px solid #D2D4DC', borderRadius: '2px', width: '15vw'
                                }} >

                                {this.state.loadedEpisodes.map(episode => (
                                    <option key={episode.id} value={episode.id} >
                                        {episode.name}
                                    </option>
                                ))}
                                <option hidden value='Select Intent Name'>Select Interaction</option>


                            </select>
                        </div>
                    </div>
                    <div className="card" >

                        <DataTable
                            data={this.state.episodeDataResults}
                            columns={dynamicCols}
                            defaultPageSize={5}
                            pageSizeOptions={[5, 10, 15]}
                            onPageChange={this.onPageChange}
                            page={this.state.pageNum}
                        />
                    </div>
                </div>
            </div >
        );
    }
}
export default ViewPatientData;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ViewPatientData.js